import { Box, BoxProps, useTheme } from '@mui/material';
import React, { forwardRef } from 'react';

import { DEFAULT_MARGIN_LARGE, DEFAULT_MARGIN_NORMAL } from '../../../Spacer/Spacer';

interface Props extends BoxProps {
  /**
   * Disable Gutters (maxWidth and spacings)
   *
   * @default false
   *
   */
  disableGutters?: boolean;

  /**
   * Disable Gap (gaps between content)
   *
   * @default false
   */
  disableGaping?: boolean;
}

export const DEFAULT_PADDING_HORIZONTAL = { xs: 5, sm: 8, md: 8, lg: 12 };

/**
 * Outer Container, providing space for 1 or more GridContainer
 *
 * @parent: Page
 * @children: GridContainer
 *
 * @constructor
 */
export const FinalContainer = forwardRef<HTMLDivElement, Props>(
  ({ children, disableGutters = false, disableGaping = false, ...rest }, ref) => {
    const theme = useTheme();

    if (disableGutters) {
      return (
        <Box
          ref={ref}
          marginLeft={0}
          marginRight={0}
          marginTop={0}
          marginBottom={0}
          paddingLeft={0}
          paddingRight={0}
          paddingTop={0}
          paddingBottom={0}
          maxWidth="none"
          display="flow-root"
          {...rest}
        >
          {children}
        </Box>
      );
    }

    return (
      <Box
        ref={ref}
        marginLeft="auto"
        marginRight="auto"
        marginTop={DEFAULT_MARGIN_LARGE}
        marginBottom={DEFAULT_MARGIN_LARGE}
        paddingLeft={DEFAULT_PADDING_HORIZONTAL}
        paddingRight={DEFAULT_PADDING_HORIZONTAL}
        paddingTop={0}
        paddingBottom={0}
        maxWidth={theme.breakpoints.values.xl}
        rowGap={disableGaping ? 0 : DEFAULT_MARGIN_NORMAL}
        display={disableGaping ? 'block' : 'flex'}
        flexDirection="column"
        {...rest}
      >
        {children}
      </Box>
    );
  }
);

FinalContainer.displayName = 'FinalContainer';
